import { qportalApi } from './qportal-api';
const getAssignmentsAndUserDocuments = () => {
    return qportalApi.get(`document/GetAllDocumentsAndAssignments`);
};
const getDocuSignSigningUrl = (assignmentId) => {
    return qportalApi.get(`docusign/signing-url/${assignmentId}`);
};
const DocumentApi = {
    getAssignmentsAndUserDocuments,
    getDocuSignSigningUrl
};
export default DocumentApi;
